// Generated types for VersioningPin
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { VersioningRowReadAPI, VersioningRowWriteAPI } from './versioningrow';
import { VersioningRowReadAPISchemaObject, VersioningRowWriteAPISchemaObject } from './versioningrow';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface VersioningPinReadAPI extends VersioningRowReadAPI {
  /** The referencing holder (node/record id). */
  holder_id: string;
  /** Holder class/type — records are never rebound. */
  holder_type: string;
  /** Owning island of a materialised pin reader; null for claims. */
  reader_holder_island?: string | null;
  /** The referenced (target) island id. */
  island_id: string;
  /** Pinned entity/subtree (default: island root). */
  entity_id: string;
  /** Pinned commit — the reconstruction coordinate (null for a record attachment made before the island's first commit). */
  commit_id?: string | null;
  /** Merkle subtree hash — the validity test. */
  content_hash?: string | null;
  /** Digest epoch the hash was computed under. */
  epoch?: string | null;
  /** Record pin whose claim has diverged (never rebound). */
  historical?: boolean;
  /** Last write (ms) — orders pins_into. */
  updated_ts?: number | null;
}

export interface VersioningPinWriteAPI extends VersioningRowWriteAPI {
  /** The referencing holder (node/record id). */
  holder_id: string;
  /** Holder class/type — records are never rebound. */
  holder_type: string;
  /** Owning island of a materialised pin reader; null for claims. */
  reader_holder_island?: string | null;
  /** The referenced (target) island id. */
  island_id: string;
  /** Pinned entity/subtree (default: island root). */
  entity_id: string;
  /** Pinned commit — the reconstruction coordinate (null for a record attachment made before the island's first commit). */
  commit_id?: string | null;
  /** Merkle subtree hash — the validity test. */
  content_hash?: string | null;
  /** Digest epoch the hash was computed under. */
  epoch?: string | null;
  /** Record pin whose claim has diverged (never rebound). */
  historical?: boolean;
  /** Last write (ms) — orders pins_into. */
  updated_ts?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const VersioningPinReadAPISchema: z.ZodType<VersioningPinReadAPI> = VersioningRowReadAPISchemaObject.extend({
  holder_id: z.string(),
  holder_type: z.string(),
  reader_holder_island: z.string().nullable().optional(),
  island_id: z.string(),
  entity_id: z.string(),
  commit_id: z.string().nullable().optional(),
  content_hash: z.string().nullable().optional(),
  epoch: z.string().nullable().optional(),
  historical: z.boolean().optional(),
  updated_ts: z.number().nullable().optional(),
}).passthrough();

export const VersioningPinWriteAPISchema: z.ZodType<VersioningPinWriteAPI> = VersioningRowWriteAPISchemaObject.extend({
  holder_id: z.string(),
  holder_type: z.string(),
  reader_holder_island: z.string().nullable().optional(),
  island_id: z.string(),
  entity_id: z.string(),
  commit_id: z.string().nullable().optional(),
  content_hash: z.string().nullable().optional(),
  epoch: z.string().nullable().optional(),
  historical: z.boolean().optional(),
  updated_ts: z.number().nullable().optional(),
}).passthrough();
